import { useEffect, useState, useRef, useContext } from "react";
import { Box, Grid, Tooltip, useTheme } from "@mui/material";
import { useFormik } from "formik";
import {  Alert, AlertTitle, TextField,  Button,  MenuItem,  Autocomplete,  Typography, } from "@mui/material";
import { tokens } from "../../theme";
//import { departamentos } from "../../data/static.js";
import { validationSchemaVocacional } from "../../data/validationSquema";
import { initialValues } from "../../data/initialValues";
import { fetchData } from "../../services/Api";
import Header from "../../components/Header";
import ModalBienvenida from "../../components/ModalBienvenida.jsx";
import ModalNuevoColegio from "../../components/ModalNuevoColegio.jsx";
import InfoIcon from '@mui/icons-material/Info';
//import ReCAPTCHA from "react-google-recaptcha";
import AppContext from '../vocacional/AppContext.js';

const Vocacional = () => {
  const theme = useTheme();
  const colors = tokens(theme.palette.mode);
  const [campus, setCampus] = useState([]);
  const [carreras, setCarreras] = useState([]);
  const [colegios, setColegios] = useState([]);
  const [departamentos, setDepartamentos] = useState([]);
  const [openModalBienvenida, setOpenModalBienvenida] = useState(false);
  const  [openModalColegio, setOpenModalColegio] = useState(false);
  const [mostrarCampoOtros, setMostrarCampoOtros] = useState(false);
  const [isButtonDisabled, setIsButtonDisabled] = useState(false);
  const [showSuccessBox, setShowSuccessBox] = useState(false);
  const [filteredColegios, setFilteredColegios] = useState([]);
  const [captchaToken, setCaptchaToken] = useState(null);
  const [showAlert, setShowAlert] = useState(false);
  const [alertMessage, setAlertMessage] = useState('');
  const { setDatosCompartidos, setIsFormCompleted } = useContext(AppContext); // Usar contexto
  //const recaptchaRef = useRef(null);
 


  const formik = useFormik({
    initialValues,
    validationSchema: validationSchemaVocacional,
    onSubmit: (values) => {
      //if (!captchaToken) {
       // setAlertMessage("Por favor, completa el reCAPTCHA antes de enviar.");
       // setShowAlert(true);
       // return;
      //}
    //  console.log("Formulario enviado con éxito:", values);
      //console.log("Token CAPTCHA:", captchaToken);
   //   console.log(values);
      
      setIsButtonDisabled(true); // Desactiva el botón
      setShowSuccessBox(true); // Muestra el Box de éxito
      setDatosCompartidos(values); 
      setIsFormCompleted(true); // Marca el formulario como completado en el contexto
      //console.log(setDatosCompartidos);
    },
  });

 
  useEffect(() => {
    const cargarDatos = async () => {
      try {
        const [campusData, carrerasData,  colegiosData, departamentoData] = await Promise.all([
          fetchData("ObtenerCampus/"),
          fetchData("ObtenerCarreras/"),
          fetchData("ObtenerColegios/"),
          fetchData("ObtenerDepartamento/"),
         // fetchData("ObtenerPreguntasInteres/")
        ]);
        setCampus(campusData);
        setCarreras(carrerasData);
        setColegios(colegiosData);
        setDepartamentos(departamentoData);
       // console.log(colegiosData);
       // setPreguntas(preguntasData)
      } catch (error) {
        console.error("Error al cargar datos:", error);
      }
    };
    cargarDatos();
  }, []);


  useEffect(() => {
    const selectedDepartamento = departamentos.find(
      (dep) => dep.id === formik.values.departamentoColegio
    )?.departamento;
  
    //console.log("Departamento seleccionado:", selectedDepartamento);
    if (!selectedDepartamento) {
      setFilteredColegios([]);
      return;
    }  
    // Filtra los colegios y extrae el departamento de "nombreColegio"
    const colegiosFiltrados = colegios.filter((colegio) => {
      // Extrae el departamento del nombreColegio
      const departamentoEnNombre = colegio.nombreColegio.split(" - ")[1]; // Esto asume que el departamento es la segunda parte del nombreColegio
  
      //console.log("Departamento extraído de nombreColegio:", departamentoEnNombre);
  
      return departamentoEnNombre === selectedDepartamento;
    });
  
    //console.log("Colegios filtrados:", colegiosFiltrados);
    setFilteredColegios(colegiosFiltrados);
  }, [formik.values.departamentoColegio, departamentos, colegios]);


  useEffect(() => {
    if (showAlert) {
      const timer = setTimeout(() => {
        setShowAlert(false);
      }, 2000); // 5000 ms = 5 segundos

      return () => clearTimeout(timer); // Limpia el temporizador al desmontar
    }
  }, [showAlert]);

   const handleCaptchaChange = (token) => {
    setCaptchaToken(token);
    console.log("Token recibido:", token); // Este token se envía al backend para validación
  };

  const handleOpenModal = () => {
    setOpenModalBienvenida(true);
  };



  const handleCloseModalColegio = () => {
    setOpenModalColegio(false);
  };

  return (
    <Box
      m="20px"
      display="flex"
      justifyContent="center"
      // sx={{
      //   backgroundImage: `url(${fondo})`,
      //   backgroundSize: "cover",
      //   backgroundPosition: "center",
      //   minHeight: "100vh",
      //   display: "grid",
      // }}
    >
      <Box width="100%" maxWidth="800px">
        <Box display="flex" justifyContent="space-between" alignItems="center">
          <Header
            title="Datos Generales"
            subtitle="Ingrese sus datos generales."
          />
        </Box>

        <form onSubmit={formik.handleSubmit}>
          <Box
            display="flex"
            justifyContent="center"
            sx={{
              backgroundColor: colors.primary, // Color de fondo
              padding: 3, // Espaciado interior
              borderRadius: 2, // Bordes redondeados
              boxShadow: 3, // Sombra para darle profundidad
            }}
          >
            <Grid container spacing={2}>
              <Grid item xs={12} sm={6}>
                <TextField
                  fullWidth
                  color="quinary"
                  variant="filled"
                  id="nombreCompleto"
                  name="nombreCompleto"
                  label="Nombre Completo"
                  value={formik.values.nombreCompleto}
                  onChange={formik.handleChange}
                  error={
                    formik.touched.nombreCompleto &&
                    Boolean(formik.errors.nombreCompleto)
                  }
                  helperText={
                    formik.touched.nombreCompleto &&
                    formik.errors.nombreCompleto
                  }
                  margin="normal"
                />
              </Grid>
              <Grid item xs={12} sm={6}>
                <>
                  <TextField
                    fullWidth
                    color="quinary"
                    variant="filled"
                    id="numeroIdentidad"
                    name="numeroIdentidad"
                    label="Número de Identidad"
                    value={formik.values.numeroIdentidad}
                    onChange={formik.handleChange}
                    onBlur={formik.handleBlur} // Asegúrate de incluir esto
                    error={
                      formik.touched.numeroIdentidad &&
                      Boolean(formik.errors.numeroIdentidad)
                    }
                    helperText={
                      formik.touched.numeroIdentidad &&
                      formik.errors.numeroIdentidad
                    }
                    margin="normal"
                    placeholder="Ingrese solo digitos."
                    InputProps={{
                      endAdornment: (
                        <Tooltip title="* Si no tienes Identidad puedes ver tu partida de nacimiento, este campo no obligatorio">
                          <InfoIcon sx={{ color: "#004cbe", cursor: "pointer", ml: 1 }} />
                        </Tooltip>
                      ),
                    }}
                  />
                </>
              </Grid>
              <Grid item xs={12} sm={6}>
                <TextField
                  select
                  fullWidth
                  color="quinary"
                  variant="filled"
                  id="sexo"
                  name="sexo"
                  label="Sexo"
                  value={formik.values.sexo}
                  onChange={formik.handleChange}
                  error={formik.touched.sexo && Boolean(formik.errors.sexo)}
                  helperText={formik.touched.sexo && formik.errors.sexo}
                  margin="normal"
                >
                  <MenuItem value="Masculino">Masculino</MenuItem>
                  <MenuItem value="Femenino">Femenino</MenuItem>
                </TextField>
              </Grid>
              <Grid item xs={12} sm={6}>
                <TextField
                  fullWidth
                  color="quinary"
                  variant="filled"
                  id="telefono"
                  name="telefono"
                  label="Teléfono"
                  value={formik.values.telefono}
                  onChange={formik.handleChange}
                  error={
                    formik.touched.telefono && Boolean(formik.errors.telefono)
                  }
                  helperText={formik.touched.telefono && formik.errors.telefono}
                  margin="normal"
                />
              </Grid>
              <Grid item xs={12} sm={6}>
                <TextField
                  fullWidth
                  color="quinary"
                  variant="filled"
                  id="correoElectronico"
                  name="correoElectronico"
                  label="Correo Electrónico"
                  value={formik.values.correoElectronico}
                  onChange={formik.handleChange}
                  error={
                    formik.touched.correoElectronico &&
                    Boolean(formik.errors.correoElectronico)
                  }
                  helperText={
                    formik.touched.correoElectronico &&
                    formik.errors.correoElectronico
                  }
                  margin="normal"
                />
              </Grid>
              <Grid item xs={12} sm={6}>
                {departamentos && (
                  <Autocomplete
                    fullWidth
                    id="departamentoResidencia"
                    options={departamentos}
                    getOptionLabel={(option) => option.departamento || ""}
                    value={
                      departamentos.find(
                        (departamento) =>
                          departamento.id ===
                          formik.values.departamentoResidencia
                      ) || null
                    }
                    onChange={(event, value) =>
                      formik.setFieldValue(
                        "departamentoResidencia",
                        value ? value.id : ""
                      )
                    }
                    isOptionEqualToValue={(option, value) =>
                      option.id === (value?.id || value)
                    }
                    renderInput={(params) => (
                      <TextField
                        {...params}
                        color="quinary"
                        variant="filled"
                        label="Departamento de tu residencia"
                        error={
                          formik.touched.departamentoResidencia &&
                          Boolean(formik.errors.departamentoResidencia)
                        }
                        helperText={
                          formik.touched.departamentoResidencia &&
                          formik.errors.departamentoResidencia
                        }
                        margin="normal"
                      />
                    )}
                  />
                )}
              </Grid>
              <Grid item xs={12} sm={6}>
          <Autocomplete
            fullWidth
            id="departamentoColegio"
            options={departamentos}
            getOptionLabel={(option) => option.departamento || ""}
            value={
              departamentos.find(
                (departamento) => departamento.id === formik.values.departamentoColegio
              ) || null
            }
            onChange={(event, value) =>
              formik.setFieldValue(
                "departamentoColegio",
                value ? value.id : ""
              )
            }
            isOptionEqualToValue={(option, value) =>
              option.id === (value?.id || value)
            }
            renderInput={(params) => (
              <TextField
                {...params}
                label="Departamento del Colegio"
                variant="filled"
                error={
                  formik.touched.departamentoColegio &&
                  Boolean(formik.errors.departamentoColegio)
                }
                helperText={
                  formik.touched.departamentoColegio &&
                  formik.errors.departamentoColegio
                }
                margin="normal"
              />
            )}
          />
        </Grid>
        <Grid item xs={12} sm={6}>
  <Autocomplete
    fullWidth
    id="colegio"
    options={[{ id: 3782, nombreColegio: "Otros" }, ...filteredColegios]} // Usa el ID correcto para "Otros"
    getOptionLabel={(option) => option.nombreColegio || ""}
    value={
      [{ id: 3782, nombreColegio: "Otros" }, ...filteredColegios].find(
        (colegioItem) => colegioItem.id === formik.values.colegio
      ) || null
    }
    onChange={(event, value) => {
      if (value?.id === 3782) { // Verifica el ID de "Otros"
        setMostrarCampoOtros(true);
        formik.setFieldValue("colegio", 3782); // Asigna el ID de "Otros"
        formik.setFieldValue("nombreOtros", ""); // Limpia el campo nombreOtros
      } else {
        setMostrarCampoOtros(false);
        formik.setFieldValue("colegio", value ? value.id : "");
        formik.setFieldValue("nombreOtros", ""); // Limpia el campo nombreOtros si se selecciona uno de la lista
      }
    }}
    isOptionEqualToValue={(option, value) =>
      option.id === (value?.id || value)
    }
    renderOption={(props, option) => (
      <li {...props} key={option.id}>
        {option.nombreColegio}
      </li>
    )}
    renderInput={(params) => (
      <TextField
        {...params}
        color="quinary"
        variant="filled"
        label="Colegio"
        error={formik.touched.colegio && Boolean(formik.errors.colegio)}
        helperText={formik.touched.colegio && formik.errors.colegio}
        margin="normal"
        InputProps={{
          ...params.InputProps,
          endAdornment: (
            <>
              {params.InputProps.endAdornment}
              <Tooltip title="Si no encuentras tu colegio, selecciona 'Otros'.">
                <InfoIcon
                  sx={{
                    color: "#004cbe",
                    cursor: "pointer",
                    ml: 1,
                    position: "relative",
                    top: "4px",
                    transform: "translateY(-50%)",
                  }}
                />
              </Tooltip>
            </>
          ),
        }}
      />
    )}
  />
  {mostrarCampoOtros && (
    <Grid item xs={12}>
      <TextField
        fullWidth
        id="nombreOtros"
        name="nombreOtros"
        label="Ingrese Nombre del Colegio"
        variant="filled"
        value={formik.values.nombreOtros || ""}
        onChange={(e) => formik.setFieldValue("nombreOtros", e.target.value)}
        error={formik.touched.nombreOtros && Boolean(formik.errors.nombreOtros)}
        helperText={formik.touched.nombreOtros && formik.errors.nombreOtros}
        margin="normal"
      />
    </Grid>
  )}
</Grid>
              <Grid item xs={12} sm={6}>
                <Autocomplete
                  fullWidth
                  color="quinary"
                  id="campusInteres"
                  options={campus}
                  getOptionLabel={(option) => option.nombreCampus || ""}
                  value={
                    campus.find(
                      (campusItem) =>
                        campusItem.idCampus === formik.values.campusInteres
                    ) || null
                  }
                  onChange={(event, value) =>
                    formik.setFieldValue(
                      "campusInteres",
                      value ? value.idCampus : ""
                    )
                  }
                  isOptionEqualToValue={(option, value) =>
                    option.idCampus === (value?.idCampus || value)
                  }
                  renderInput={(params) => (
                    <TextField
                      {...params}
                      color="quinary"
                      variant="filled"
                      label="Campus de Interés"
                      error={
                        formik.touched.campusInteres &&
                        Boolean(formik.errors.campusInteres)
                      }
                      helperText={
                        formik.touched.campusInteres &&
                        formik.errors.campusInteres
                      }
                      margin="normal"
                    />
                  )}
                />
              </Grid>
              <Grid item xs={12} sm={6}>
                <Autocomplete
                  fullWidth
                  color="quinary"
                  id="carreraInteres"
                  options={carreras}
                  getOptionLabel={(option) => option.nombreCarrera || ""}
                  value={
                    carreras.find(
                      (carraraItem) =>
                        carraraItem.idCarrera === formik.values.carreraInteres
                    ) || null
                  }
                  onChange={(event, value) =>
                    formik.setFieldValue(
                      "carreraInteres",
                      value ? value.idCarrera : ""
                    )
                  }
                  isOptionEqualToValue={(option, value) =>
                    option.idCarrera === (value?.idCarrera || value)
                  }
                  renderInput={(params) => (
                    <TextField
                      {...params}
                      color="quinary"
                      variant="filled"
                      label="Carrera de Interés"
                      error={
                        formik.touched.carreraInteres &&
                        Boolean(formik.errors.carreraInteres)
                      }
                      helperText={
                        formik.touched.carreraInteres &&
                        formik.errors.carreraInteres
                      }
                      margin="normal"
                    />
                  )}
                />
              </Grid>
            </Grid>
          </Box>
          <Box display="flex" justifyContent="center" mt={2} mb={0}>
      </Box>{showAlert && (
        <Alert  variant="filled" severity="error" >
          <AlertTitle>Error</AlertTitle>
          {alertMessage}
        </Alert>
      )}
          <Button
            color="quinary"
            variant="contained"
            fullWidth
            type="submit"
            disabled={isButtonDisabled} // Desactiva el botón
            sx={{
              mt: 2,
              color: "white",
            }}
          >
            Enviar
          </Button>
        </form>

        {showSuccessBox  && (
          <Box
            sx={{
              mt: 3,
              p: 3,
              border: "1px solid",
              borderRadius: 1,
              backgroundColor: colors.primary[400],
              textAlign: "center",
              boxShadow: 3,
            }}
          >
            <Typography
              variant="h5"
              gutterBottom
              sx={{ fontWeight: "bold", color: "quinary.main" }}
            >
              ¡Todos los datos completados!
            </Typography>
            <Typography
              variant="body1"
              gutterBottom
              sx={{ mb: 2, color: "text.secondary" }}
            >
              Da click en el botón Iniciar para comenzar el ¡test!
            </Typography>
            <Button
              onClick={handleOpenModal}
              variant="contained"
              color="secondary"
              sx={{
                mt: 2,
                backgroundColor: "quinary.main",
                color: "white",
                "&:hover": { backgroundColor: "quinary.dark" },
              }}
            >
              Iniciar
            </Button>
          </Box>
        )}
      </Box>
      <ModalBienvenida
        openModalBienvenida={openModalBienvenida}
        nombre={formik.values.nombreCompleto}
      />
      <ModalNuevoColegio
        open={openModalColegio}
        onClose={handleCloseModalColegio}
        //onAgregar={handleAgregarColegio}
      />
    </Box>
  );
};

export default Vocacional;
